<template>
    <div v-bind:class="{'d-none': !showItem}" class="row" style="margin-top: 10px;">
        <div class="col-12">
            <div class="form-group" style="width: 100%;">
                <label :for="item.key">{{ item.label }}</label>
                <div>
                    <vue-timepicker 
                        :id="item.key"
                        :name="item.key"
                        :placeholder="item.label"
                        :hour-range="this.getHourRange()"
                        v-model="itemValue"
                        format="HH:mm"
                        autocomplete="off"
                        close-on-complete
                        input-class="form-control"
                        input-width="100%"></vue-timepicker>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import EventBus from '../../../../EventBus'
    import VueTimepicker from 'vue2-timepicker'

    export default {
        props: [
            'item',
            'restaurant'
        ],

        components: { VueTimepicker },

        data () {
            return {
                itemValue: null,
                startHour: "0:00",
                endHour: "23:59",
                showItem: true,
            }
        },

        created() {
            var _this = this;
            EventBus.$on('serviceTypeFormValueUpdated', (data) => {
                if (data.key == 'is_programmed') {
                    if (data.value == 'Adesso' || data.value == 'adesso') {
                        _this.showItem = false;
                    } else {
                        _this.showItem = true;
                    }
                }
            });
        },

        mounted() {
            var _this = this;

            let serviceTypeConfig = this.restaurant.service_type_config;
            if (serviceTypeConfig.service_type_time && serviceTypeConfig.service_type_time.start) {
                this.startHour = serviceTypeConfig.service_type_time.start;
            }
            if (serviceTypeConfig.service_type_time && serviceTypeConfig.service_type_time.end) {
                this.endHour = serviceTypeConfig.service_type_time.end;
            }
        },

        watch: {
            itemValue: function(newValue, oldValue) {
                var time = newValue.HH + ":" + newValue.mm;
                EventBus.$emit('serviceTypeFormValueUpdated', {
                    key: this.item.key,
                    value: time
                });
            }
        },

        methods: {
            getHourRange: function() {
                var startHourInt = parseInt(this.startHour.split(':')[0]);
                var endHourInt = parseInt(this.endHour.split(':')[0]);
                return [[startHourInt, endHourInt]];
            }
        }
    }
</script>
